// import {
//   replaceInvalidityUi,
//   fieldAddError,
//   fieldRemoveError,
//   closestFormItem,
// } from '../utils/form';
import $ from 'jquery';

//元素位置回调
$.fn.position_callback = function (opt) {
  let selector = this.selector;
  $(this).each(function () {
    let $this = $(this);
    if (!$this.length) {
      console.warn('元素 ' + selector + ' 未找到');
      return;
    }
    let ele = $this[0];
    let options = {
      offsetTop: 0,
      offsetBottom: 0,
      scrollEle: window,
      // topUp: function () {},
      // topDown: function () {},
      // bottomUp: function () {},
      // bottomDown: function () {},
    };
    options = $.extend(options, opt);
    let scroll_position_callback = '';
    let scroll_position_callback_flag =
      'scroll_position_callback_' + (selector + '').replace(/[^a-zA-Z\d]/g, '_');
    if (!$this.data(scroll_position_callback_flag)) {
      let position_callback_uuid_count = $('body').data('position_callback_uuid_count');
      if (!position_callback_uuid_count) position_callback_uuid_count = 0;

      $('body').data('position_callback_uuid_count', ++position_callback_uuid_count);
      $this.data(
        scroll_position_callback_flag,
        scroll_position_callback_flag + '_' + position_callback_uuid_count,
      );
    }
    scroll_position_callback = $this.data(scroll_position_callback_flag);
    let throughTop = false;
    let throughBottom = false;
    $(options.scrollEle)
      .off('scroll.' + scroll_position_callback)
      .on('scroll.' + scroll_position_callback, () => {
        let { top, bottom } = ele.getBoundingClientRect();
        if (top < options.offsetTop) {
          if (!throughTop) {
            options.topUp && options.topUp.call($this);
            throughTop = true;
          }
        } else {
          if (throughTop) {
            options.topDown && options.topDown.call($this);
            throughTop = false;
          }
        }
        if (bottom < options.offsetBottom) {
          if (!throughBottom) {
            options.bottomUp && options.bottomUp.call($this);
            throughBottom = true;
          }
        } else {
          if (throughBottom) {
            options.bottomDown && options.bottomDown.call($this);
            throughBottom = false;
          }
        }
      });
  });
};

//计算内部元素高度
$.fn.childHeight = function (callback) {
  let h = 0;
  this.children().each(function () {
    h += $(this).height();
  });
  callback && callback();
  return h;
};

// 带margin
$.fn.childAllHeight = function (callback) {
  let height = this.height();
  let childHeight = 0;
  this.children().each(function () {
    childHeight += $(this).outerHeight(true);
  });
  callback && callback();
  return childHeight > height ? childHeight : height;
};

// //验证表单
// $.fn.replaceInvalidityUi = function () {
//   this.each(function () {
//     if (this.tagName !== 'FORM' || this._replaceInvalidityUi) return;
//     replaceInvalidityUi(this);
//     this._replaceInvalidityUi = true;
//   });
// };
// $.fn.fieldAddError = function (err) {
//   this.each(function () {
//     fieldAddError(closestFormItem(this), err);
//   });
// };
// $.fn.fieldRemoveError = function () {
//   this.each(function () {
//     fieldRemoveError(closestFormItem(this) || this);
//   });
// };
